<template>
  <div>
    <button @click="$modal.show('uploadModal')" style="margin-left:12px;width: 140px" class="button text-primary">{{ title }}</button>

    <modal name="uploadModal" :adaptive="true" :width="600" height="auto" class="modal-style"
           @closed="onCloseUpload">
      <div class="lp-modal-wrapper">
        <admin-box-item title="상품 파일 업로드"
                        :useTab="false"
                        subtitle="* 먼저 양식을 다운로드 하고, 양식에 업로드할 내용을 입력하신 뒤 업로드 해주세요.">
          <div class="columns is-multiline">
            <div class="column is-full" style="height: 200px">
              <div style="margin-bottom: 4px">양식 내려받기</div>
              <button class="button is-primary"
                      style="margin-bottom:12px"
                      @click="clickDownload">다운로드</button>
              <div>상품 파일 업로드</div>
              <input-file :value.sync="uploadFile"
                          :acceptExt="'.xlsx'"
                          style="width:50%"
                          description=""
                          :maxLength="1"></input-file>
            </div>

            <div class="btn-group-justify-end">
              <button class="button is-light" @click="$modal.hide('uploadModal')">취소</button>
              <button class="button is-primary" @click="clickUpload">확인</button>
            </div>
          </div>
        </admin-box-item>
      </div>
    </modal>

    <modal name="resultDownloadProgress" :click-to-close="false">
      <div class="lp-modal-wrapper result-download-progess-wrapper" v-if="resultDownloadProgress">
        <div style="margin-bottom:20px">{{ title }}</div>
        성공: {{ resultDownloadProgress.success }} <br>
        실패: {{ resultDownloadProgress.fail }}
        <div v-if="resultDownloadProgress.fail_res.length>0">
          <div>실패한 번호</div>
          <div class="fail-excel-number-wrapper">
            <div v-for="(number, excel_idx) in resultDownloadProgress.fail_res"
                 :key="`excel-number-${excel_idx}`">
              <span>{{ number }}</span>
              <span v-if="excel_idx < resultDownloadProgress.fail_res.length-1">,</span>
            </div>
          </div>
        </div>
        <button class="button is-primary close-button"
                @click="$modal.hide('resultDownloadProgress')"
                v-if="showCancelButton">닫기</button>
      </div>
    </modal>
  </div>
</template>
<script>
  import InputFile from "../../../module/common/InputFile";
  export default {
    name: "ProductInfoExcelUpload",
    components: {InputFile},
    created() {
    },
    data() {
      return {
        title: '엑셀 파일로 상품 등록',
        uploadFile: [],
        resultDownloadProgress: {success:0, fail:0, fail_res: []},
        showCancelButton: false
      }
    },
    methods: {
      clickUpload() {
        this.showCancelButton = false;
        this.resultDownloadProgress = {success:0, fail:0, fail_res: []}
        let config = {
          onDownloadProgress: res => {
            let result = "[" + res.target.response.slice(0,-1) + "]";
            result = JSON.parse(result).slice(-1)[0];
            this.resultDownloadProgress = result;
          }
        };

        if(this.uploadFile.length===0) {
          this.toast('파일을 첨부해주세요.');
          return;
        }
        let params = {
          file: this.uploadFile[0].file
        };

        this.$modal.hide('uploadModal');
        this.$modal.show('resultDownloadProgress');

        this.$axios.post('admin/product/xlsx', params, config).then(res=> {
          this.showCancelButton = true;
          this.toast('파일 업로드 되었습니다.');
          // this.$modal.hide('resultImageProgress');
          this.onCloseUpload();
        }).catch(() => {
          this.toast('서버에 오류가 있습니다.');
          this.$modal.hide('resultDownloadProgress');
        });
      },
      clickDownload() {
        this.$axios.get('admin/product/xlsx').then(res => {
          location.href=res.data.file;
        });
      },
      onCloseUpload() {
        this.uploadFile = [];
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .result-download-progess-wrapper
    height 100%
    font-size 15px
    .close-button
      position absolute
      right 20px
      bottom 20px

  .fail-excel-number-wrapper
    height 110px
    overflow-y scroll
    border 1px solid rgb(206 206 206)
    margin-top 4px
    padding 4px
    display flex
    flex-wrap wrap
</style>
